import React, { useContext } from "react";
import pic1 from "../img/proj1.png";
import pic2 from "../img/proj2.png";
// import pic3 from "../img/proj3.png";
import pic5 from "../img/proj5.png";
import pic6 from "../img/proj6.png";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ThemeContext } from "../context";
import "./Css/projslider.css";
import { GitHub, Launch } from "@mui/icons-material";
import { Box } from "@mui/material";

const Projectslider = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    LargeDesktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 500 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 500, min: 0 },
      items: 1,
    },
  };

  const projectshere = [
    {
      id: 1,
      title: "MERN stack E-Commerce",
      tools: ["React", "Express", "Mongoose", "JWT", "SASS"],
      img: pic1,
      github: "https://github.com/Deepangshi",
      link: "https://react-thread-trove.netlify.app/",
    },
    {
      id: 2,
      title: "Food App",
      tools: ["React", "API", "SASS"],
      img: pic2,
      github: "https://github.com/Deepangshi",
      link: "https://restaurantfood-app.netlify.app/",
    },
    {
      id: 3,
      title: "Clinic app",
      tools: ["JAVA", "MYSQL", "JavaSwing"],
      img: pic5,
      github: "https://github.com/Deepangshi/java-MediTrack.git",
      link: "https://github.com/Deepangshi/java-MediTrack.git",
    },
    {
      id: 4,
      title: "Language-translator-react",
      tools: ["React, Javascript, HTML, CSS"],
      img: pic6,
      github: "https://github.com/Deepangshi",
      link: "https://language-translator-react.netlify.app/",
    },
  ];

  return (
    <div
      style={{
        height: "100%",
        padding: "0px 10px 0px 10px",
      }}
    >
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        removeArrowOnDeviceType={[
          "tablet",
          "desktop",
          "LargeDesktop",
          "mobile",
        ]}
      >
        {projectshere.map((item) => (
          <div
            key={item.id}
            style={{
              margin: "20px",
              border: darkMode ? "2px solid #a79149" : "2px solid #a5a5a5",
              borderRadius: "10px 10px 0px 0px",
              overflow: "hidden",
              height: "40vh",
              boxShadow: darkMode ? "0 0 20px #d4af37" : "0 0 20px #a5a5a5",
            }}
            className="projs"
          >
            <Box
              sx={{
                // display: { xs: "block", lg: "block" },
                height: "25px",
                backgroundColor: "rgba(0,0,0,0.7)",
                position: "sticky",
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                padding: "0 10px",
                gap: "8px",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ff605c", // red
                }}
              />
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ffbd44", // yellow
                }}
              />
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#00ca4e", // green
                }}
              />
            </Box>
            <div className="p-herelink">
              <a href={item.link} target="_blank" rel="noreferrer" width="100%">
                <img width="100%" src={item.img} alt="" className="ps-img" />
              </a>

              <div
                className="content"
                style={{
                  background: darkMode
                    ? "rgba(0, 0, 0, 0.6)"
                    : "rgba(112, 110, 110, 0.6)",
                }}
              >
                <div className="content-t">{item.title}</div>

                <div className="content-c">
                  <a href={item.github} target="_blank" rel="noreferrer">
                    <GitHub
                      sx={{
                        size: 24,
                        color: darkMode ? "#fff" : "#000",
                      }}
                    />
                  </a>
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <Launch
                      sx={{
                        size: 24,
                        marginLeft: "8px",
                        color: darkMode ? "#fff" : "#000",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* <div>
          <img src={pic1} alt="" />
        </div>

        <div>
          <img src={pic2} alt="" />
        </div>
        <div>
          <img src={pic1} alt="" />
        </div>
        <div>
          <img src={pic2} alt="" />
        </div> */}
      </Carousel>
    </div>
  );
};

export default Projectslider;
